export default __webpack_public_path__ + "static/media/thumbnail.a895e928.png";